import React from 'react'

const ListIcon = (
  <>
    <path
      d="M32.7118 8.79752L24.6752 0.760965C24.1846 0.270231 23.5322 0 22.8383 0H7.125C5.69265 0 4.52734 1.16531 4.52734 2.59766V35.4023C4.52734 36.8347 5.69265 38 7.125 38H30.875C32.3073 38 33.4727 36.8347 33.4727 35.4023V10.6344C33.4727 9.94064 33.2025 9.28833 32.7118 8.79752ZM29.6717 8.90625H24.9375C24.7329 8.90625 24.5664 8.73978 24.5664 8.53516V3.80104L29.6717 8.90625ZM30.875 35.7734H7.125C6.92038 35.7734 6.75391 35.607 6.75391 35.4023V2.59766C6.75391 2.39304 6.92038 2.22656 7.125 2.22656H22.3398V8.53516C22.3398 9.9675 23.5052 11.1328 24.9375 11.1328H31.2461V35.4023C31.2461 35.607 31.0796 35.7734 30.875 35.7734Z"
      fill="#E55AA1"
    />
    <path
      d="M20.1948 16.9961H27.288C27.9028 16.9961 28.4013 16.4976 28.4013 15.8828C28.4013 15.268 27.9028 14.7695 27.288 14.7695H20.1948C19.58 14.7695 19.0815 15.268 19.0815 15.8828C19.0815 16.4976 19.5799 16.9961 20.1948 16.9961Z"
      fill="#E55AA1"
    />
    <path
      d="M20.1948 24.418H27.288C27.9028 24.418 28.4013 23.9195 28.4013 23.3047C28.4013 22.6899 27.9028 22.1914 27.288 22.1914H20.1948C19.58 22.1914 19.0815 22.6899 19.0815 23.3047C19.0815 23.9195 19.5799 24.418 20.1948 24.418Z"
      fill="#E55AA1"
    />
    <path
      d="M27.3198 29.6133H20.1948C19.58 29.6133 19.0815 30.1117 19.0815 30.7266C19.0815 31.3414 19.58 31.8398 20.1948 31.8398H27.3198C27.9347 31.8398 28.4331 31.3414 28.4331 30.7266C28.4331 30.1117 27.9347 29.6133 27.3198 29.6133Z"
      fill="#E55AA1"
    />
    <path
      d="M14.6402 12.8515L12.0728 15.4188L11.4674 14.8134C11.0327 14.3786 10.3277 14.3786 9.89297 14.8134C9.4582 15.2481 9.4582 15.953 9.89297 16.3878L11.2856 17.7804C11.503 17.9978 11.7879 18.1065 12.0728 18.1065C12.3576 18.1065 12.6426 17.9979 12.8599 17.7804L16.2145 14.4259C16.6493 13.9911 16.6493 13.2862 16.2145 12.8515C15.7798 12.4167 15.0749 12.4167 14.6402 12.8515Z"
      fill="#E55AA1"
    />
    <path
      d="M14.6402 20.8401L12.0728 23.4075L11.4674 22.8021C11.0327 22.3674 10.3277 22.3673 9.89297 22.8021C9.4582 23.2369 9.4582 23.9417 9.89297 24.3765L11.2856 25.7691C11.503 25.9864 11.7879 26.0951 12.0728 26.0951C12.3576 26.0951 12.6426 25.9864 12.8599 25.769L16.2145 22.4145C16.6493 21.9797 16.6493 21.2748 16.2145 20.8401C15.7798 20.4054 15.0749 20.4054 14.6402 20.8401Z"
      fill="#E55AA1"
    />
    <path
      d="M14.6402 28.262L12.0728 30.8294L11.4674 30.224C11.0327 29.7893 10.3277 29.7892 9.89297 30.224C9.4582 30.6587 9.4582 31.3636 9.89297 31.7984L11.2856 33.1909C11.503 33.4083 11.7879 33.517 12.0728 33.517C12.3576 33.517 12.6426 33.4083 12.8599 33.1909L16.2145 29.8363C16.6493 29.4016 16.6493 28.6967 16.2145 28.2619C15.7798 27.8272 15.0749 27.8272 14.6402 28.262Z"
      fill="#E55AA1"
    />
  </>
)

export default ListIcon
